import { priceFormatter } from '@mojility/coach-core';

export default class WorkspaceQuestionnairePurchaseController {
  constructor($scope, questionnaire, workspace, workspaceInteractor, localize, close) {
    this.$scope = $scope;
    this.questionnaire = questionnaire;
    this.workspace = workspace;
    this.workspaceInteractor = workspaceInteractor;
    this.localize = localize;
    this.close = close;

    this.canPurchase = true;
    this.canGoToQuestionnaire = false;
  }

  processTokenPromise(promise) {
    promise
      .then(token => {
        this.canPurchase = false;
        this.$scope.$digest();
        this.purchaseWithToken(token);
      }, error => this.handleStripeError(error))
      .then(() => this.$scope.$digest());
  }

  purchaseWithToken(token) {
    return this.workspaceInteractor.purchaseQuestionnaire(this.workspace, this.questionnaire, token)
      .then(response => {
        this.canGoToQuestionnaire = true;
        this.questionnaireUrl = response.investigate_url;
        this.$scope.$digest();
      });
  }

  purchaseForFree() {
    this.canPurchase = false;
    return this.purchaseWithToken(undefined);
  }

  handleStripeError(error) {
    this.errorMessage = error.message;
  }

  get questionnairePrice() {
    return this.questionnaire.price == 0.0 ? this.localize.string('free') : priceFormatter(this.questionnaire.price);
  }

  get completingPurchase() {
    return !this.canPurchase && !this.canGoToQuestionnaire;
  }

  get cardRequired() {
    return this.questionnaire.price != 0.0;
  }
}